import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterVertical24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconGutterVertical24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 4.75a.75.75 0 0 0-1.5 0A2.75 2.75 0 0 0 6.75 7.5h10.5A2.75 2.75 0 0 0 20 4.75a.75.75 0 0 0-1.5 0c0 .69-.56 1.25-1.25 1.25H6.75C6.06 6 5.5 5.44 5.5 4.75M6.003 12a.75.75 0 0 1 .75-.75H17.25a.75.75 0 0 1 0 1.5H6.753a.75.75 0 0 1-.75-.75m13.247 8a.75.75 0 0 1-.75-.75c0-.69-.56-1.25-1.25-1.25H6.75c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 0 1 2.75-2.75h10.5A2.75 2.75 0 0 1 20 19.25a.75.75 0 0 1-.75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterVertical24);
